import Vue from 'vue';
import Vuex from 'vuex';
import { getFileName } from '@/utils/index';
Vue.use(Vuex);

/**
 * 动态导入store
 * 只要是在modules文件夹下的.js的文件都会被引入
 */
const requireStore = require.context('./module', false, /\.js$/);
const modules = {};
requireStore.keys().forEach((path) => (modules[getFileName(path)] = requireStore(path).default));
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules,
    plugins: [],
});
